import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/homeData';

export default function LatestNews() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新爆料
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              每日更新，吃瓜不迷路
            </p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {latestArticles.slice(0, 8).map((article) => (
            <Link
              key={article.id}
              to="/category/all"
              className="group block rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span
                  className={`absolute top-3 right-3 px-2.5 py-1 rounded-full text-[11px] font-semibold text-background-50 ${article.tagColor} whitespace-nowrap`}
                >
                  {article.tag}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 via-black/30 to-transparent">
                  <h3 className="text-sm md:text-base font-semibold text-background-50 leading-snug line-clamp-2">
                    {article.title}
                  </h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs md:text-sm text-foreground-700 leading-relaxed line-clamp-2 mb-3">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-md">
                    {article.category}
                  </span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}